





















import Vue from 'vue';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  props: {
    propClass: String,
  },
  data() {
    return {
      statusText: '',
      statusClass: '',
    };
  },
  computed: {
    statusClassComputed() {
      let result = '';
      if (this.statusClass) {
        result += `${this.statusClass} `;
      }
      if (this.propClass) {
        result += `${this.propClass} `;
      }
      return result;
    },
    styleComputed() {
      return (this.$route.path.startsWith(RoutePaths.DRILL_FLASHCARDS)
      || this.$route.path.startsWith('video flashcards')) // fixme video flashcards
        ? 'width: 100%; bottom: 1%; position: absolute; left: 0%;'
        : 'width: 100%; top: 2%; position: absolute; left: 0%;';
    },
  },
  methods: {
    updateScore(score: number, text: string, writingActivity = false) {
      if (score > 0.79) {
        if (writingActivity) {
          if (score === 1) {
            this.statusClass = 'green--text';
            Vue.prototype.$greenPlayer.play();
          } else {
            this.statusClass = 'orange--text';
            Vue.prototype.$yellowPlayer.play();
          }
        } else {
          this.statusClass = 'green--text';
          Vue.prototype.$greenPlayer.play();
        }
      } else if (score > 0.5) {
        this.statusClass = 'orange--text';
        Vue.prototype.$yellowPlayer.play();
      } else {
        this.statusClass = 'red--text';
        Vue.prototype.$redPlayer.play();
      }
      if (text) {
        if ((writingActivity && score === 1) || (!writingActivity && score > 0.79)) {
          this.statusText = this.$store.state.tr.Correct;
        } else {
          this.statusText = this.$store.state.tr.SorryIncorrect;
        }
      } else if (text === '') {
        this.statusText = '';
      } else {
        this.statusText = `${this.$store.state.tr.YourCurrentScore} ${String(Math.round(score * 100))}%`;
      }
    },
    updateText(str: string) {
      this.statusText = str;
    },
    clearStatus() {
      this.statusText = '';
    },
  },
});
